import { axiosReq } from "utils";
import { PaymentPurchaseActions } from "./PaymentsPurchaseReducers";
import { toast } from "sonner";

export const getPublishableKeyAction = (getToken) => {
  return async (dispatch) => {
    try {
      const token = await getToken();
      dispatch(PaymentPurchaseActions.getPublishableKeyRequest());
      const response = await axiosReq({
        method: "get",
        url: `${process.env.REACT_APP_BACKEND_URL}/stripe/key`,
        headers: {
          Authorization: `Bearer ${token}`,
        },
        withCredentials: true,
      });

      dispatch(PaymentPurchaseActions.getPublishableKeySuccess(response.data));
    } catch (error) {
      console.log(error);
      dispatch(PaymentPurchaseActions.getPublishableKeyFailure(error.message));
    }
    dispatch(clearAll());
  };
};

//create hiring session
export const createPurchaseSession = (getToken, data, navigate) => {
  return async (dispatch) => {
    dispatch(PaymentPurchaseActions.createPurchaseSessionRequest());
    try {
      const token = await getToken();
      const response = await axiosReq({
        method: "post",
        url: `${process.env.REACT_APP_BACKEND_URL}/stripe/create`,
        headers: {
          Authorization: `Bearer ${token}`,
        },
        withCredentials: true,
        data,
      });
      dispatch(
        PaymentPurchaseActions.createPurchaseSessionSuccess(response.data)
      );
      navigate("/createPaidChallenge/stripe");
    } catch (error) {
      toast.error(error.response?.data?.message || error.message);
      dispatch(
        PaymentPurchaseActions.createPurchaseSessionFailure(
          error.response?.data?.message || error.message
        )
      );
    }
    dispatch(clearAll());
  };
};

//create hiring session
export const createPurchaseSessionNew = (data, navigate) => {
  return async (dispatch) => {
    dispatch(PaymentPurchaseActions.createPurchaseSessionRequest());
    try {
      const response = await axiosReq({
        method: "post",
        url: `${process.env.REACT_APP_BACKEND_URL}/stripe/createStart`,

        withCredentials: true,
        data,
      });
      dispatch(
        PaymentPurchaseActions.createPurchaseSessionSuccess(response.data)
      );
      navigate("/createPaidChallenge/stripe");
    } catch (error) {
      console.log(error);
      toast.error(error.response?.data?.message || error.message);
      dispatch(
        PaymentPurchaseActions.createPurchaseSessionFailure(
          error.response?.data?.message || error.message
        )
      );
    }
    dispatch(clearAll());
  };
};
//clear all
export const clearAll = () => async (dispatch) => {
  setTimeout(() => {
    dispatch(PaymentPurchaseActions.clearAll());
  }, 3000);
};
